import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { GameRoundSearchOrder } from '@/globalTypes';
import {
  GameProviderParam,
  GameRoundSearchOrderParam,
  GameRoundStatusParam,
} from '@/utils/query/params';

export const queryParams = {
  gameRoundId: StringParam,
  status: GameRoundStatusParam,
  gameRoundCompleted: BooleanParam,
  gameProviderId: GameProviderParam,
  gameId: StringParam,
  from: DateTimeParam,
  to: DateTimeParam,
  desc: withDefault(BooleanParam, true),
  orderBy: withDefault(
    GameRoundSearchOrderParam,
    GameRoundSearchOrder.lastProcessedAt,
  ),
  first: withDefault(NumberParam, 20),
  before: StringParam,
  after: StringParam,
};
